export const environmentProd = {
  priismApptApiEndPoint: "/api/v1",
  priismApiEndPoint: "https://priism.in/priismapp/v1"
};
